import { memo, useMemo } from "react";

import StatusCellWrapper from "./StatusCellWrapper";
import { isLightColor } from "../../../lib/script";
import Tag from "../../fragments/Tag";

function StatusCellInner({ itemKey, caseData, text, classes, classesCell, noDataCell, itemData, rowData }) {
    const { textColor, bkColor, cellClassName } = useMemo(() => {
        let nextColor = null;
        let nextTextColor = null;
        let nextBkColor = null;

        if (text && text.color) {
            nextColor = text.color.split(" ").join("_");
        }

        if (text && text.color_code) {
            nextBkColor = text.color_code;
            const lightDark = isLightColor(text.color_code);
            nextTextColor = lightDark ? "var(--text)" : "var(--white)";
        }

        const cellClass = `${classes.status_cell} ${classesCell.body_cell} ${nextColor ? "bk_" + nextColor : ""} ${
            noDataCell ? classesCell.no_data_cell : ""
        } ${text && text.is_exhausted ? classes.exhausted_cell : ""}`;

        return { textColor: nextTextColor, bkColor: nextBkColor, cellClassName: cellClass };
    }, [text, classes.status_cell, classes.exhausted_cell, classesCell.body_cell, classesCell.no_data_cell, noDataCell]);

    //old useeffect code
    // const [color, setColor] = useState(null)
    // const [textColor, setTextColor] = useState(null)

    // const [bkColor, setBkColor] = useState(null)
    // useEffect(() => {
    //     if (text && text.color) {
    //         setColor(text.color.split(" ").join("_"))       
    //     }

    //     if (text && text.color_code) {
    //         setBkColor(text.color_code)
    //         let lightDark = isLightColor(text.color_code)
    //         setTextColor(lightDark ? 'var(--text)' : 'var(--white)')            
    //     } else {
    //         setTextColor(null)
    //         setBkColor(null)
    //     }
    // }, [text])

    return (
        <StatusCellWrapper itemKey={itemKey} caseData={caseData}>
            <div style={{ backgroundColor: bkColor, color: textColor }} className={cellClassName}>
                {text && text.is_exhausted == true && <Tag color="Red">Exhausted</Tag>}
                {text && text.label}
            </div>
        </StatusCellWrapper>
    );
}

export default memo(StatusCellInner);